import { PageWrapper } from '@/domain/vertraege/pages/PageWrapper';
import { Route, Routes } from 'react-router-dom';

export function Vertraege() {
  return (
    <Routes>
      <Route path="/" element={<PageWrapper />} />
    </Routes>
  );
}
